// extracted by mini-css-extract-plugin
module.exports = {"card":"PastWebinars_card__q68tW","accordion":"PastWebinars_accordion__s7e3u"};